{
  "name": "spot-on-frontend",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "tsc -b && vite build",
    "build:staging": "tsc -b && vite build --mode staging",
    "build:sandbox": "tsc -b && vite build --mode sandbox",
    "build:production": "tsc -b && vite build --mode production",
    "ci:build": "pnpm run build:sandbox",
    "ci:lint": "pnpm run format:check && pnpm run lint",
    "ci:test": "pnpm run test:run",
    "lint": "eslint .",
    "preview": "vite preview",
    "biome:write": "pnpm exec biome lint --write ./src",
    "format:check": "biome format .",
    "format": "biome format . --write",
    "test": "vitest",
    "test:run": "vitest run",
    "test:coverage": "vitest run --coverage"
  },
  "engines": {
    "node": ">=24.0.0 <25.0.0"
  },
  "lint-staged": {
    "*": [
      "biome format . --write",
      "eslint --fix"
    ]
  },
  "dependencies": {
    "@bugsnag/js": "9.1.0",
    "@lukemorales/query-key-factory": "1.3.4",
    "@mapbox/search-js-core": "1.6.0",
    "@mapbox/search-js-react": "1.6.0",
    "@radix-ui/react-alert-dialog": "1.2.1",
    "@radix-ui/react-checkbox": "1.4.1",
    "@radix-ui/react-dialog": "1.3.1",
    "@radix-ui/react-dropdown-menu": "2.2.1",
    "@radix-ui/react-label": "2.1.17",
    "@radix-ui/react-popover": "1.3.1",
    "@radix-ui/react-progress": "1.2.1",
    "@radix-ui/react-roving-focus": "1.2.1",
    "@radix-ui/react-separator": "1.2.0",
    "@radix-ui/react-slider": "1.6.1",
    "@radix-ui/react-slot": "1.5.0",
    "@radix-ui/react-toggle": "1.2.1",
    "@radix-ui/react-toggle-group": "1.2.1",
    "@radix-ui/react-tooltip": "1.4.1",
    "@tailwindcss/vite": "4.3.3",
    "@tanstack/query-core": "5.105.0",
    "@tanstack/react-query": "5.105.0",
    "@tanstack/react-query-devtools": "5.105.0",
    "@tanstack/react-table": "9.3.1",
    "@turf/turf": "7.4.0",
    "axios": "1.20.0",
    "class-variance-authority": "0.7.1",
    "clsx": "2.1.1",
    "cmdk": "1.1.1",
    "date-fns": "4.4.0",
    "framer-motion": "14.6.0",
    "lucide-react": "1.61.0",
    "mapbox-gl": "3.33.0",
    "mixpanel-browser": "2.84.0",
    "react": "19.3.1",
    "react-dom": "19.3.1",
    "react-dropzone": "20.1.4",
    "react-error-boundary": "6.1.6",
    "react-hook-form": "7.91.0",
    "react-router": "8.5.0",
    "sonner": "2.0.8",
    "tailwind-merge": "3.7.0",
    "tailwindcss": "4.3.3",
    "zustand": "5.0.16"
  },
  "devDependencies": {
    "@biomejs/biome": "2.6.3",
    "@commitlint/cli": "21.2.4",
    "@commitlint/config-conventional": "21.2.4",
    "@eslint/js": "10.0.1",
    "@mapbox/mapbox-gl-style-spec": "14.33.0",
    "@svgr/plugin-jsx": "8.1.0",
    "@svgr/plugin-svgo": "8.1.0",
    "@tanstack/eslint-plugin-query": "5.105.0",
    "@testing-library/dom": "10.4.2",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@testing-library/user-event": "14.6.8",
    "@typescript/native": "npm:typescript@7.0.2",
    "@types/geojson": "7946.0.16",
    "@types/mapbox-gl": "3.5.0",
    "@types/node": "26.6.5",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@vitejs/plugin-react": "6.1.2",
    "@vitest/coverage-v8": "5.0.5",
    "eslint": "10.13.0",
    "eslint-config-biome": "2.1.3",
    "eslint-config-prettier": "10.1.8",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-plugin-import-x": "4.17.1",
    "eslint-plugin-react-hooks": "7.1.1",
    "eslint-plugin-react-refresh": "0.5.7",
    "globals": "17.13.0",
    "husky": "9.1.7",
    "jsdom": "30.1.3",
    "lint-staged": "17.6.0",
    "prettier": "3.9.10",
    "sharp": "0.35.5",
    "svgo": "4.1.0",
    "typescript": "npm:@typescript/typescript6@6.0.2",
    "typescript-eslint": "8.72.0",
    "vite": "8.3.5",
    "vite-plugin-image-optimizer": "2.0.3",
    "vite-plugin-svgr": "5.2.0",
    "vitest": "5.0.5"
  }
}
